export default __webpack_public_path__ + "static/media/allfaqs-folders.612b735e.svg";